/**
 * Shared map configuration constants.
 */

export const WEST_LAFAYETTE_CENTER = { lat: 40.4471459, lng: -86.9546152 };

/** @type {number} Initial map zoom before location fit. */
export const INITIAL_ZOOM = 18.75;

/** @type {number} Feet-to-meters conversion factor. */
export const FEET_TO_METERS = 0.3048;

/** @type {number} Default visible radius around the user, in miles (desktop). */
export const RADIUS_MILES = 0.15;

/** @type {number} Default visible radius around the user, in meters (desktop). */
export const RADIUS_METERS = RADIUS_MILES * 1609.34;

/** @type {number} Location radius on mobile viewports, in feet. */
export const MOBILE_RADIUS_FEET = 350;

/** @type {number} Max CSS viewport width treated as mobile. */
export const MOBILE_MAX_WIDTH_PX = 768;

/** @type {PositionOptions} */
export const GEO_OPTIONS = {
	enableHighAccuracy: true,
	timeout: 10000,
	maximumAge: 60000,
};

/** @type {string} localStorage key for the last known user location. */
export const STORED_LOCATION_KEY = 'sumy_neighborhood_map_user_location';

/** @type {number} Max voter URLs to prefetch per visibility update. */
export const PREFETCH_MAX = 40;

/** @type {number} Debounce delay before prefetching, in milliseconds. */
export const PREFETCH_DEBOUNCE_MS = 200;

/**
 * Whether the current viewport should use mobile map sizing.
 *
 * @return {boolean} True when the viewport is at or below the mobile breakpoint.
 */
export function isMobileViewport() {
	return window.matchMedia( `(max-width: ${ MOBILE_MAX_WIDTH_PX }px)` ).matches;
}

/**
 * Returns the active location-radius in meters for the current viewport.
 *
 * @return {number} Radius in meters.
 */
export function getLocationRadiusMeters() {
	if ( isMobileViewport() ) {
		return MOBILE_RADIUS_FEET * FEET_TO_METERS;
	}
	return RADIUS_METERS;
}

/**
 * Whether the URL requests showing every marker (skip radius filter).
 *
 * @return {boolean} True when `view=showAll` is present in the query string.
 */
export function isShowAllView() {
	const params = new URLSearchParams( window.location.search );
	return 'showAll' === params.get( 'view' );
}
